import styled from "styled-components";

export const PopoverBg = styled.div`
  // position: fixed;
  // width: 100vw;
  // height: 100vh;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 100;
`;
